import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"
import { memberReactorKey } from "@productlane/lib/src/message-reactions"

import type { MutatorTx } from "../schema"
import type { ToggleMessageReactionArgs } from "../types"

export const messageReactionMutators = {
	toggle: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: ToggleMessageReactionArgs
			ctx: ZeroJwtPayload
		}) => {
			if (authData.role === "VIEWER") {
				throw new Error("Viewers can't react to messages")
			}
			const reactorKey = memberReactorKey(authData.userId)
			const existing = await tx.query.messageReactions
				.where("workspaceId", authData.workspaceId)
				.where("messageType", args.messageType)
				.where("messageId", args.messageId)
				.where("emoji", args.emoji)
				.where("reactorKey", reactorKey)
				.one()
				.run()

			if (existing) {
				await tx.mutate.messageReactions.delete({ id: existing.id })
				return
			}

			await tx.mutate.messageReactions.insert({
				id: args.id,
				createdAt: Date.now(),
				messageType: args.messageType,
				messageId: args.messageId,
				emoji: args.emoji,
				imageUrl: args.imageUrl ?? null,
				source: "APP",
				reactorKey,
				reactorName: null,
				workspaceId: authData.workspaceId,
				threadId: args.threadId,
				userId: authData.userId,
			})
		},
	),
}
